<h1 mat-dialog-title id="dialogLoaderTitle">Loading File(s)</h1>
<div mat-dialog-content id="dialogLoaderContent">
  <p>We are processing your EANs file(s), please wait</p>
  <mat-spinner></mat-spinner>
</div>
